// src/AdminLogin.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // ✅ استخدم useNavigate بدل useHistory

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const navigate = useNavigate(); // ✅ إنشاء navigate

  const handleLogin = () => {
    if (password === '1234') {
      localStorage.setItem('isAdmin', 'true');
      localStorage.setItem('lastActive', Date.now());
      navigate('/admin'); // ✅ التنقل باستخدام useNavigate
    } else {
      alert('كلمة المرور غير صحيحة');
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="bg-white p-8 shadow rounded w-96">
        <h2 className="text-2xl font-bold mb-4 text-center">تسجيل دخول المدير</h2>
        <input
          type="password"
          placeholder="أدخل كلمة المرور"
          className="w-full mb-4 p-2 border rounded"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          onClick={handleLogin}
          className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700"
        >
          تسجيل الدخول
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;
